import { selectResultsStatus } from './selectResultsStatus';
import { IApplicationState } from '../../types/redux';
import { EResultsStatus } from '../../types/results';

export const selectIsResultsLoading = (state: IApplicationState) => {
  return selectResultsStatus(state) === EResultsStatus.Loading;
};
